import React from 'react';
import {XRDomOverlay} from '@react-three/xr';
import {useARStore} from 'stores';
import {ARButtonCamera, ARButtonFolder, ARButtonQuit, ARButtonRemove, ARButtonScreenshotPreview} from '../buttons';

import ARUIPlace from './AR.UI.Place';
import ARUIScan from './AR.UI.Scan';

interface IARCoreUIProps {
  onScreenshot: () => void;
}

const ARCoreUI = ({onScreenshot}: IARCoreUIProps) => {
  const modelData = useARStore(s => s.modelData);
  const hasHitTest = useARStore(s => s.hasHitTest);
  return (
    <XRDomOverlay>
      {/* Buttons */}
      <ARButtonQuit />

      {/* <ARButtonToggle /> */}
      <ARButtonScreenshotPreview />
      <ARButtonCamera onScreenshot={onScreenshot} />
      <ARButtonRemove />
      <ARButtonFolder />

      {/* UI */}
      {!!modelData && !hasHitTest && <ARUIScan />}
      {!!modelData && hasHitTest && <ARUIPlace />}
    </XRDomOverlay>
  );
};

export default React.memo(ARCoreUI);
